import React, { useMemo } from 'react';
import { MdOutlineBolt, MdOutlineSatelliteAlt } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { Top as TopUI, TopStatusValue, TopNotificationCount } from '@/components/ui/dashboard/Top';

const Top = ({ robot }) => {
  const batteryStatus = useSelector((state) => state.telemetry[robot.id].batteryStatus);
  const gpsRaw = useSelector((state) => state.telemetry[robot.id].gpsRaw);

  const labels = useMemo(() => {
    const draftLabels = [robot.model.agentType];

    // GPS 보정 시
    if ([5, 6].includes(gpsRaw?.fixType)) {
      draftLabels.push('RTK');
    }

    return draftLabels;
  }, [gpsRaw]);

  const voltage = useMemo(() => {
    if (!batteryStatus) return;

    return (batteryStatus.voltage / 1000).toFixed(1);
  }, [batteryStatus]);

  return (
    <TopUI labels={labels}>
      <TopStatusValue Icon={MdOutlineBolt} value={voltage} unit="V" />
      <TopStatusValue Icon={MdOutlineSatelliteAlt} value={gpsRaw?.satellitesVisible} style={{ gap: 4 }} />
      <TopNotificationCount robotId={robot.id} />
    </TopUI>
  );
};

export default Top;
